import { useAskRedoSlidePanel } from "@redotech/redo-merchant-app-common/ask-redo/ask-redo-slide-panel-context";
import {
  createContext,
  memo,
  type ReactNode,
  useCallback,
  useContext,
  useMemo,
} from "react";

interface FullPageAskRedoNavigationContextValue {
  threadId: string | undefined;
  preserveConversation: () => void;
}

const FullPageAskRedoNavigationContext =
  createContext<FullPageAskRedoNavigationContextValue | null>(null);

export const FullPageAskRedoThreadProvider = memo(
  function FullPageAskRedoThreadProvider({
    children,
    threadId,
  }: {
    children: ReactNode;
    threadId: string | undefined;
  }) {
    const { open } = useAskRedoSlidePanel();
    const preserveConversation = useCallback(() => {
      if (threadId) {
        open({ kind: "thread", threadId });
      }
    }, [open, threadId]);
    const value = useMemo(
      () => ({ preserveConversation, threadId }),
      [preserveConversation, threadId],
    );

    return (
      <FullPageAskRedoNavigationContext.Provider value={value}>
        {children}
      </FullPageAskRedoNavigationContext.Provider>
    );
  },
);

export function useFullPageAskRedoNavigation(): FullPageAskRedoNavigationContextValue | null {
  return useContext(FullPageAskRedoNavigationContext);
}
